import { useState } from 'react';
import { IndustryVisual } from './IndustryVisual';
import { SectionHeading } from './SectionHeading';
import { Typography } from './Typography';
import { Button } from './Button';
import { Plus, Minus } from 'lucide-react';
import styles from './IndustriesSection.module.css';
const industries = [
  {
    name: 'Промышленные предприятия',
    description:
      'Проверка запасов, оборудования и основных средств на производственных и складских площадках со сложной инфраструктурой.',
  },
  {
    name: 'Государственные организации',
    description:
      'Аудиторская проверка и сопутствующие услуги для организаций государственного сектора. Среди клиентов — НК «Kazakh Tourism».',
  },
  {
    name: 'Распределённые объекты',
    description:
      'Инвентаризация на нескольких площадках и в разных регионах с единой методикой проверки и итоговой отчётностью.',
  },
];
export function IndustriesSection() {
  const [active, setActive] = useState(0);
  return (
    <section className={styles.section}>
      <IndustryVisual />
      <div className={styles.copy}>
        <SectionHeading eyebrow="Отрасли" title="Реальный опыт. Сложные объекты." align="start" />
        <div className={styles.list}>
          {industries.map((x, i) => (
            <div key={x.name} className={styles.item}>
              <button
                aria-expanded={active === i}
                aria-controls={`industry-${i}`}
                onClick={() => setActive(active === i ? -1 : i)}
              >
                <Typography as="span" variant="cardTitle">
                  {x.name}
                </Typography>
                {active === i ? <Minus size={18} aria-hidden /> : <Plus size={18} aria-hidden />}
              </button>
              <div id={`industry-${i}`} hidden={active !== i}>
                <Typography tone="muted">{x.description}</Typography>
              </div>
            </div>
          ))}
        </div>
        <Button href="/cases/">Смотреть проекты</Button>
      </div>
    </section>
  );
}
